import { Box, Button } from '@mui/material'
import React from 'react'

const StepperButtons = ({ activeStep, title, handleBack, handleNext, handleSaveQuery, handleExecuteQuery, showQueryInfo }) => {
    return (
        <Box>
            {!showQueryInfo ? (
                <>
                    {!title && (
                        <Button
                            size="small"
                            disabled={activeStep === 0}
                            onClick={() => handleBack()}
                            sx={{ flex: 1, m: 1 }}
                            variant="contained"
                        >
                            Back
                        </Button>
                    )}
                    <Button
                        size="small"
                        onClick={() => handleSaveQuery()}
                        sx={{ flex: 1, m: 1 }}
                        variant="contained"
                        color="secondary"
                    >
                        Save Query
                    </Button>
                    <Button
                        size="small"
                        onClick={() => handleExecuteQuery()}
                        sx={{ flex: 1, m: 1 }}
                        variant="contained"
                        color="success"
                    >
                        Execute Query
                    </Button>
                </>
            ) : (
                <>
                    {activeStep !== 0 && (
                        <Button
                            size="small"
                            onClick={() => handleSaveQuery()}
                            sx={{ flex: 1, m: 1 }}
                            variant="contained"
                            color="secondary"
                        >
                            Save Query
                        </Button>
                    )}
                    <Button
                        size="small"
                        id="continue-button"
                        onClick={() => handleNext()}
                        variant="contained"
                        sx={{ m: 1, backgroundColor: '#04aeea', color: 'white' }}
                    >
                        {activeStep === 0 ? "Begin" : "Continue"}
                    </Button>
                </>
            )}
        </Box>
    )
}

export default StepperButtons